import * as React from 'react';
import {
    QuestionCircleRegular
} from "@fluentui/react-icons";
import { Caption1, Card, CardHeader, Divider, LargeTitle, Text, makeStyles, tokens } from '@fluentui/react-components';
import { Link } from 'react-router-dom';
import { flexColumn } from '../../styles/GlobalStyles';
import { articles, ArticleType } from '../articles/KnowledgeArticleIndex';

const useStyles = makeStyles({
    root: {
        borderRadius: "5px",
        width: "100%",
        height: "100%"
    },
    caption: {
        color: tokens.colorNeutralForeground3,
    },
    text: { margin: "0" },
    card: {
        width: "100%",
        height: "fit-content",
        cursor: "pointer"
    },
    seemlessLink: {
        color: "unset",
        textDecoration: "none"
    },
    flexColumn
});

export interface GeneralDocumentationProps
{
    title: string;
    articleType: ArticleType;
}

export const DocumentationPage: React.FC<GeneralDocumentationProps> = React.memo(({ title, articleType }) => {
    const styles = useStyles();    

    return (
        <div className={styles.root}>
            <div className={styles.flexColumn}>
                <LargeTitle>{title}</LargeTitle>

                <Divider />
                
                { articles[articleType].map( a => (
                    <Link className={styles.seemlessLink} to={`/docs/${articleType}/article/${a.id}`}>
                        <Card key={a.id} className={styles.card}>
                            <CardHeader
                                image={
                                    <QuestionCircleRegular fontSize="36px" />
                                }
                                header={<Text weight="semibold">{a.title}</Text>}
                                description={
                                    <Caption1 className={styles.caption}>{a.subtitle}</Caption1>
                                }
                            />

                            <p className={styles.text}>
                                { a.description }
                            </p>
                        </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
});